'use client';

import React from 'react';

import { Button, ButtonProps, Tooltip } from '@mantine/core';

import { CompanyHelpers } from 'helpers/CompanyHelpers';
import { MarketingHelpers } from 'helpers/MarketingHelpers';

import { useProfileUpgrade } from 'hooks/use-profile-upgrade';

export const SignUpOrUpgradeButton = ({ signup = false, ...buttonProps }: ButtonProps & { signup?: boolean }) => {
    const { upgrade, isLoading } = useProfileUpgrade();

    if (isLoading) {
        return (
            <Button size="lg" loading {...buttonProps}>
                Upgrade your profile
            </Button>
        );
    }

    if (upgrade) {
        return (
            <Tooltip label={upgrade.companyName} withArrow>
                <Button size="lg" component="a" href={upgrade.url} {...buttonProps}>
                    Upgrade your profile
                </Button>
            </Tooltip>
        );
    }

    if (signup) {
        return (
            <Button
                size="lg"
                component="a"
                href={`/login?redirect=${encodeURIComponent(CompanyHelpers.urls.create())}`}
                {...buttonProps}
            >
                Sign up as a PRO
            </Button>
        );
    }

    return (
        <Button size="lg" component="a" href={MarketingHelpers.urls.resourcepro.joinAsPro()} {...buttonProps}>
            Join as a PRO
        </Button>
    );
};
